import IconExpandLess from "@mui/icons-material/ExpandLessRounded";
import IconExpandMore from "@mui/icons-material/ExpandMoreRounded";
import {
  UiBox,
  UiCircularProgress,
  UiIconFlagEn,
  UiIconFlagEs,
  UiIconFlagKk,
  UiIconFlagPt,
  UiIconFlagRo,
  UiIconFlagRu,
  UiIconFlagUk,
  UiMenuItem,
} from "@smp/ui";
import { forwardRef, useCallback } from "react";

import { languageTitles } from "./menu_item_language.static";
import { IProps } from "./menu_item_language.types";

export const MenuItemLanguage = forwardRef<HTMLLIElement, IProps>(
  ({ isExpanded, isExpander, isLoading, languageCode, onClick }, ref) => {
    const handleClick = useCallback(() => {
      onClick && onClick(languageCode);
    }, [languageCode, onClick]);

    const flagByLanguageCode = {
      en: <UiIconFlagEn />,
      es: <UiIconFlagEs />,
      kk: <UiIconFlagKk />,
      pt: <UiIconFlagPt />,
      ro: <UiIconFlagRo />,
      ru: <UiIconFlagRu />,
      uk: <UiIconFlagUk />,
    }[languageCode];

    return (
      <UiMenuItem ref={ref} onClick={handleClick}>
        <UiBox display="flex" flexDirection="row" width="100%">
          <UiBox
            alignItems="center"
            display="flex"
            flexGrow={0}
            paddingRight={1}
          >
            {flagByLanguageCode}
          </UiBox>
          <UiBox alignItems="center" display="flex" flexGrow={1}>
            {languageTitles[languageCode]}
          </UiBox>
          {isExpander && (
            <UiBox alignItems="center" display="flex" flexGrow={0}>
              {isExpanded ? <IconExpandLess /> : <IconExpandMore />}
            </UiBox>
          )}
          {!isExpander && isLoading && (
            <UiBox alignItems="center" display="flex" flexGrow={0}>
              <UiCircularProgress size={16} />
            </UiBox>
          )}
        </UiBox>
      </UiMenuItem>
    );
  },
);
